import { LocaleContext } from 'components/MainComponent/MainComponent'
import { useContext } from 'react'
import styled from 'styled-components'

export const Age = ({
  colorMode,
  data,
}: {
  colorMode: 'dark' | 'light' | undefined
  data: { label: string; value: number[] }[]
}) => {
  let TEXT = useContext(LocaleContext).agechart
  const colors =
    colorMode === 'dark'
      ? [
          'rgba(255, 228, 98,1)',
          'rgba(255, 228, 98,.6)',
          'rgba(255, 228, 98,.3)',
        ]
      : ['#16514F', '#60B9B7', '#D4D4D4']
  const textcolors =
    colorMode === 'dark'
      ? ['#121212', '#121212', '#fff']
      : ['#fff', '#202346', '#202346']

  return (
    <ConsumptionRoot>
      {data.map((element) => {
        return <Bar colorMode={colorMode} data={element} />
      })}
      <Key>
        {[TEXT[5], <>3 &mdash; 6 {TEXT[6]}</>, <>1 &mdash; 2 {TEXT[6]}</>].map(
          (entry, i) => {
            return (
              <Entry>
                <Swatch style={{ backgroundColor: colors[i] }} />
                {entry}
              </Entry>
            )
          }
        )}
      </Key>
    </ConsumptionRoot>
  )
}

const Key = styled.div`
  display: flex;
  margin-top: 15px;
  flex-wrap: wrap;
`

const Bar = ({
  colorMode,
  data,
}: {
  colorMode: 'dark' | 'light' | undefined
  data: { label: string; value: number[] }
}) => {
  const { label, value } = data
  const max = 80
  const width = value.map((value) => (value / max) * 100)
  console.log(width)
  const colors =
    colorMode === 'dark'
      ? [
          'rgba(255, 228, 98,1)',
          'rgba(255, 228, 98,.6)',
          'rgba(255, 228, 98,.3)',
        ]
      : ['#16514F', '#60B9B7', '#D4D4D4']
  const textcolors =
    colorMode === 'dark'
      ? ['#121212', '#121212', '#fff']
      : ['#fff', '#202346', '#202346']

  return (
    <BarRoot
      style={{
        borderBottom:
          colorMode === 'dark'
            ? '1px solid var(--gray-2)'
            : '1px solid var(--gray-4)',
      }}
    >
      <Label>
        <div>{label}</div>
      </Label>
      <BarInner>
        <BarSize
          style={{
            width: width[0] + '%',
            backgroundColor: colors[0],
            color: textcolors[0],
          }}
        >
          <>{value[0].toLocaleString("de-CH").replace(".",",")}</>
        </BarSize>
        <BarSize
          style={{
            width: width[1] + '%',
            backgroundColor: colors[1],
            color: textcolors[1],
          }}
        >
          <>{value[1].toLocaleString("de-CH").replace(".",",")}</>
        </BarSize>
        <BarSize
          style={{
            width: width[2] + '%',
            backgroundColor: colors[2],
            color: textcolors[2],
          }}
        >
          <>{value[2].toLocaleString("de-CH").replace(".",",")}</>
        </BarSize>
      </BarInner>
    </BarRoot>
  )
}

const Entry = styled.div`
  flex: 1 1 auto;

  padding-right: 5px;
  font-size: 12px;
  white-space: nowrap;
  @media only screen and (max-width: 711px) {
    flex: 0 0 40%;
  }
`
const Swatch = styled.div`
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 10px;
`

const BarRoot = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 15px;
  padding-top: 2px;
  padding-bottom: 2px;
`

const BarInner = styled.div`
  flex: 1 1 auto;
`

const BarSize = styled.div`
  text-align: right;
  padding-right: 5px;
  color: var(--site-background);
  background-color: #f00;
  display: inline-block;
  border-right: 1px solid #fff;
  font-size: 12px;
`
const Label = styled.div`
  flex: 0 0 150px;
  display: flex;

  @media only screen and (max-width: 711px) {
    flex: 0 0 65px;
  }
  img {
    flex: 0 0 40px;
    max-width: 40px;
  }
  div {
    flex: 1 1 auto;
    line-height: 1.2em;

    span {
      display: inline-block;
      width: 100%;
      font-weight: 700;
    }
  }
`

const ConsumptionRoot = styled.div`
  width: 100%;
  margin-bottom: 15px;
`
